import React from 'react'

/**
 * Revert the general decorator spacing so content edge aligns with window edge
 * aligns fixed content like sticky footer
 */
export const FullLayout: React.FC<any> = function FullLayout(props) {
  return <div style={{ margin: '-8px' }} {...props} />
}
